import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeAnalytics } from './Functions/ga4';

const deferAnalyticsBootstrap = () => {
  if (typeof window === 'undefined') return;
  const run = () => {
    try {
      initializeAnalytics();
    } catch {}
  };

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 2500 });
    return;
  }

  window.setTimeout(run, 1200);
};

deferAnalyticsBootstrap();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
